// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"contact__Wrapper__1KycI","fadeInLoad":"contact__fadeInLoad__2XxB7","FormData":"contact__FormData__3i6Aa","BtnContainer":"contact__BtnContainer__26CD7","Form":"contact__Form__UU4xN","ContactContainer":"contact__ContactContainer__r-sP-","ContactIMG":"contact__ContactIMG__3V0-v","ContactInfo":"contact__ContactInfo__1rQNn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contact/contact.css
// module id = 104
// module chunks = 0